import api from './api';

export const taskTemplatesAPI = {
  list: (params) => api.get('/api/task-templates', { params }),
  get: (id) => api.get(`/api/task-templates/${id}`),
  create: (data) => api.post('/api/task-templates', data),
  update: (id, data) => api.put(`/api/task-templates/${id}`, data),
  duplicate: (id) => api.post(`/api/task-templates/${id}/duplicate`),
  setActive: (id, isActive) => api.post(`/api/task-templates/${id}/activate`, { is_active: isActive }),
  reset: (id) => api.post(`/api/task-templates/${id}/reset`),
  periods: (periodType, financialYear) => api.get('/api/task-periods', { params: { period_type: periodType, financial_year: financialYear } }),
};

export const taskExtrasAPI = {
  replaceChecklist: (taskId, items) => api.put(`/api/tasks/${taskId}/checklist`, { items }),
  patchItem: (taskId, itemId, data) => api.patch(`/api/tasks/${taskId}/checklist/${itemId}`, data),
  upload: (taskId, file) => { const f = new FormData(); f.append('file', file); return api.post(`/api/tasks/${taskId}/attachments`, f); },
  download: (taskId, attId) => api.get(`/api/tasks/${taskId}/attachments/${attId}/download`, { responseType: 'blob' }),
  removeAttachment: (taskId, attId) => api.delete(`/api/tasks/${taskId}/attachments/${attId}`),
};

export const CATEGORY_LABELS = { A: 'Income Tax Returns', B: 'BAS', C: 'IAS', D: 'Payroll & Super', E: 'ASIC & Company', F: 'SMSF', G: 'Other Tax Compliance', H: 'Bookkeeping & Reporting' };
export const ENTITY_LABELS = { individual: 'Individual', sole_trader: 'Sole trader', partnership: 'Partnership', company: 'Company', trust: 'Trust', smsf: 'SMSF', other: 'Other' };
export const PERIOD_LABELS = { financial_year: 'Financial year', quarter: 'Quarter', month: 'Month', fbt_year: 'FBT year', none: 'No period' };
export const TASK_STATUS = [
  { id: 'todo', title: 'To Do' }, { id: 'in_progress', title: 'In Progress' }, { id: 'waiting_client', title: 'Waiting on client' },
  { id: 'in_review', title: 'In review' }, { id: 'done', title: 'Done' },
];

export const taskAutomationAPI = {
  suggest: (templateId, periodKey) => api.get('/api/task-deadlines/suggest', { params: { template_id: templateId, period_key: periodKey || undefined } }),
  rules: () => api.get('/api/task-deadline-rules'),
  createRule: (data) => api.post('/api/task-deadline-rules', data),
  updateRule: (id, data) => api.put(`/api/task-deadline-rules/${id}`, data),
  ruleAction: (id, action, params) => api.post(`/api/task-deadline-rules/${id}/${action}`, null, { params }),
  putSetting: (templateId, data) => api.put(`/api/task-deadline-settings/${templateId}`, data),
  recurrences: () => api.get('/api/task-recurrences'),
  recurrence: (id) => api.get(`/api/task-recurrences/${id}`),
  patchRecurrence: (id, data) => api.patch(`/api/task-recurrences/${id}`, data),
  recurrenceAction: (id, action) => api.post(`/api/task-recurrences/${id}/${action}`),
  bulkPreview: (data) => api.post('/api/tasks/bulk/preview', data),
  bulkCreate: (data) => api.post('/api/tasks/bulk/create', data),
  search: (params) => api.get('/api/tasks/search', { params }),
};
export const REPEAT_LABELS = { none: 'One-time', monthly: 'Monthly', quarterly: 'Quarterly', annually: 'Annually', custom: 'Custom' };
export const repeatText = (r) => (r.frequency === 'custom' ? `every ${r.interval_months} months` : r.frequency);
export const shortDate = (v) => (v ? new Date(`${String(v).slice(0, 10)}T00:00:00`).toLocaleDateString('en-AU', { day: 'numeric', month: 'short', year: 'numeric' }) : '');
